import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { ValList } from '@/common/val/ValList';

export const McdClaimLineDetail = () => {
  
  const { entityObj } = useEntityMgr();
  const { navState } = useNavState();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="MCD_UTIL_LINE" parentEntityId={entityObj.id} partition={navState.partition}/>},
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}